import { IShareOfShelfSaveDto } from "../../models/dto/agendaApi/IShareOfShelfDto";
import * as ApiWithToken from "../callApiWithToken";

const shareOfShelfService = {
    getBrandsFilters: async function (languageId: number, appointmentId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `ShareOfShelf/getBrandFilters?languageId=${languageId}&appointmentId=${appointmentId}`);
    },
    saveInformation(shareOfShelf: IShareOfShelfSaveDto[]) {
        return ApiWithToken.postApi(process.env.REACT_APP_GENERAL_API + `Sync/sos`, shareOfShelf);
    },
    getShareOfShelf: async function () {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `ShareOfShelf/getShareOfShelf`);
    }
}

export default shareOfShelfService;